import { render, staticRenderFns } from "./BrandsDetail.vue?vue&type=template&id=6603fb96&scoped=true&"
import script from "./BrandsDetail.vue?vue&type=script&lang=js&"
export * from "./BrandsDetail.vue?vue&type=script&lang=js&"
import style0 from "./BrandsDetail.vue?vue&type=style&index=0&id=6603fb96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6603fb96",
  null
  
)

export default component.exports